module.exports = __webpack_public_path__ + "assets/img/6bd912de26b2c206022bc7dc6fd71fdd.png";